import { useParams } from 'react-router-dom-v5'

export const useCampaignCode = () => {
  // NOTE: code is route merchant, campaignID is route campaign
  const { code, campaignID } = useParams<{ code?: string, campaignID?: string }>()
  return { campaignCodeFromUrl: (code ?? campaignID) || '' }
}
